<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
        <v-flex xs12>
          <v-toolbar
            color="#eee"
            class="elevation-0 secondary--text" >
            <v-toolbar-title>Bandeiras</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip>
              <v-btn icon color='info' slot="activator" @click="dialog = true">
                <v-icon>add</v-icon>
              </v-btn>
              <span>Adicionar Bandeira</span>
            </v-tooltip>
          </v-toolbar>
          <v-dialog v-model="dialog" lazy :fullscreen="$vuetify.breakpoint.xs" width="500">
            <cad-bandeira
              v-if="dialog"
              @fechar="dialog = false, bandeira = undefined"
              @info="showInfo"
              @error="showError"
              :bandeira="bandeira"
              @carregar="carregarBandeiras"
            ></cad-bandeira>
          </v-dialog>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headersBandeiras"
            :items="bandeiras"
            :loading="loading"
            :pagination.sync="pagination"
            :total-items="totalItems"
            hide-actions
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.nome }}</td>
              <td>{{ props.item.referencia }}</td>
              <td class="text-xs-center">
                <v-menu
                  offset-x
                  left
                  transition="slide-x-reverse-transition"
                >
                  <template v-slot:activator="{ on }">
                      <v-btn icon flat small color="error" v-on="on">
                          <v-icon>delete</v-icon>
                      </v-btn>
                  </template>
                  <v-card
                      width="30em"
                      style="
                          border-radius: 1em;
                      "
                  >
                    <v-card-title class="justify-center">
                        <h2>Tem certeza que deseja Excluir?</h2>
                    </v-card-title>
                    <v-card-actions class="justify-space-around">
                        <v-btn
                            round
                            small
                        >
                            Não
                        </v-btn>
                        <v-btn
                            round
                            small
                            color="error"
                            @click="apagarBandeira(props.item)"
                        >
                            Sim
                        </v-btn>
                    </v-card-actions>
                  </v-card>
              </v-menu>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      flat
                      icon
                      color="info"
                      @click="function  () {
                        bandeira = props.item
                        dialog = true
                      }
                      "
                    >
                     <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Bandeira</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-snackbar
            v-model="snackbar.active"
            :color="snackbar.color"
            :multi-line="snackbar.multiLine"
            :timeout="snackbar.timeout"
            :vertical="snackbar.vertical"
        >
            {{ snackbar.text }}
        <v-btn
            flat
            @click="snackbar.active = false"
        >
            Fechar
        </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import CadBandeira from '@/components/cadastros/CadBandeira'
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: { CadBandeira, SmartLockMessage },
  data () {
    return {
      dialog: false,
      pagination: {},
      bandeiras: [],
      totalItems: 0,
      bandeira: undefined,
      headersBandeiras: [
        { text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        { text: 'Referência',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        {
          value: '',
          sortable: false,
          align: 'center'
        }
      ],
      list_bandeiras: [],
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  watch: {
    pagination: {
      handler () {
        this.carregarBandeiras()
      },
      deep: true
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        this.carregarBandeiras()
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.carregarBandeiras()
    }
  },
  methods: {
    detalhar (idBandeira) {
      this.$root.$router.push(`bandeira/detalhes/?id_bandeira=${idBandeira}`)
    },
    carregarBandeiras () {
      this.$store.dispatch('gerenciarBandeiras', {
        method: 'GET',
        parametros: {
          page: this.pagination.page
        }
      }).then(json => {
        this.bandeiras = json.results
        this.totalItems = json.count
      })
    },
    apagarBandeira (bandeira) {
      this.$store.dispatch('gerenciarBandeiras', {
        method: 'DELETE',
        id: bandeira.id
      }).then(() => {
        this.pagination.page = this.bandeiras.length > 1 ? this.pagination.page : 1
        this.carregarBandeiras()
      })
    },
    fecharDialogBandeira () {
      this.dialog = false
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
